module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header-title-wrapper"
  }, [_c('div', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subTitle) ? _c('div', {
    staticClass: "header-sub-title-wrapper"
  }, [_c('span', {
    staticClass: "header-sub-title"
  }, [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f87e7cbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/common/rtHeaderTitle.vue
// module id = 1553
// module chunks = 91